import dateTimeFormats from "constants/dateTimeFormats";

export const common = {
  ...dateTimeFormats.reduce(
    (acc, format) => {
      acc[format] = `{{date, ${format}}}`;

      return acc;
    },
    {} as Record<(typeof dateTimeFormats)[number], string>
  ),
  theAmountToValueMustBeGreater:
    "The 'Amount to' value must be greater than or equal to the 'Amount from' value",
  apiAccess: "API Access",
  utc: "UTC",
  regulatedByTheFCA: "Regulated by the FCA",
  download: "Download",
  noItemsFitTheCriteria: "No items fit the criteria.",
  noItemsFound: "No items found.",
  noResultsFound: "No results found",
  retry: "Retry",
  readLess: "Read Less",
  readMore: "Read More",
  applications: "Applications",
  connectAccounts: "Connect: Accounts",
  contactSupport: "Contact support",
  accountNumber: "Account number",
  accountHolderName: "Account holder name",
  login: "Login",
  forgotPassword: "Forgot password",
  resetPassword: "Reset password",
  expand: "Expand",
  sendATest: "Send a test",
  ccy: "Ccy",
  merchant: "Merchant",
  accountsSidebarTitle: "Accounts",
  account: "Account",
  accounts_plural: "{{count}} accounts",
  accounts: "{{count}} account",
  dashboard: "Dashboard",
  dateUtc: "Date (UTC)",
  active: "Active",
  addedBy: "Added by",
  add: "Add",
  addNew: "Add new",
  Administration: "Administration",
  name: "Name",
  surname: "Surname",
  expandAll: "Expand all",
  collapseAll: "Collapse all",
  expirationDate: "Expiration date (UTC)",
  providers: "Providers",
  users: "Users",
  userSettings: "User settings",
  status: "Status",
  refresh: "Refresh",
  all: "All",
  allCustomers: "All Customers",
  allowlist: "Allowlist",
  newItems: "New items",
  amount: "Amount",
  amountFrom: "Amount from",
  amountTo: "Amount to",
  overview: "Overview",
  generated: "Generated",
  Applications: "Applications",
  approveRequest: "Approve request",
  areYouSureYouWantToLeave: "Are you sure you want to leave this page?",
  auAccountNumber: "Au account number",
  authSecureInfo: "Secure, safe and trusted",
  "Bank accounts": "Bank accounts",
  bankName: "Bank name",
  banks: "Banks",
  bank: "Bank",
  blocklist: "Blocklist",
  bsb: "BSB",
  cancel: "Cancel",
  cancelRequest: "Cancel request",
  cannotLoadCustomerNames:
    "Cannot load customer names. Please try again later.",
  cashManagement: "Cash Management",
  accountName: "Account name",
  accountIdentifier: "Account identifier",
  checkoutBranding: "Checkout branding",
  circuitBreaker: "Circuit Breaker",
  customerBankList: "Customer bank list",
  inProgress: "In progress",
  verificationFailed: "Verification failed",
  clearFilters: "Clear filters",
  clearSearch: "Clear search",
  "Client applications": "Client applications",
  comment: "Comment",
  configuration: "Configuration",
  configure: "Configure",
  confirm: "Confirm",
  connect: "Connect",
  continue: "Continue",
  copiedToClipboard: "Copied to clipboard",
  Copy: "Copy",
  country: "Country",
  create: "Create",
  close: "Close",
  noFilters: "NO FILTERS",
  maxCharacters: "Max. characters: {{count}}",
  applyFilters: "Apply",
  wouldYouLikeToApplyThemNow: "Would you like to apply them now?",
  CURRENCY: "{{data, CURRENCY}}",
  currency: "Currency",
  currentSecretKeyWillBeInvalidated:
    "Current secret key will be invalidated immediately.",
  customer: "Customer",
  showLess: "Show Less",
  showMoreFilters: "show more",
  showLessFilters: "show less",
  customerName: "Customer name",
  bankAccounts: "Bank accounts",
  customers: "Customers",
  newPublicKey: "New public key",
  editPaymentConfigurationCountries: "Edit payment configuration countries",
  newDynamicBeneficiary: "New dynamic beneficiary",
  Dashboard: "Dashboard",
  date: "Date",
  deactivate: "Deactivate",
  declineRequest: "Decline request",
  delete: "Delete",
  details: "Details",
  detailsNew: "Details (new)",
  settlementSettings: "Settlement settings",
  editSettlementSettings: "Edit settlement settings",
  paymentDetails: "Payment details",
  paymentNotifications: "Payment notifications",
  editPaymentNotifications: "Edit payment notifications",
  verifyNotifications: "Verify notifications",
  editVerifyNotifications: "Edit verify notifications",
  notifications: "Notifications",
  newPayByLink: "New Pay by Link",
  refunds: "Refunds",
  urlToReceiveTheVoltAccountsInformation:
    "URL to receive the volt accounts information",
  redirecting: "Redirecting...",
  reference: "Reference",
  remove: "Remove",
  disable: "Disable",
  disabled: "Disabled",
  dontApply: "Don’t apply",
  doesNotBelongToSelectedCustomer:
    "{{resource}} does not belong to selected customer {{customerName}}",
  "Don't have an account yet?": "Don't have an account yet?",
  doYouWantCreateNewNotificationSecret:
    "Do you want to generate a new notification secret?",
  edit: "Edit",
  editNew: "Edit (new)",
  "Email address": "Email address",
  enable: "Enable",
  enabled: "Enabled",
  enterApplicationName: "Enter application's name",
  failingNotificationAlertEmail: "Failing notifications alert e-mail",
  Filter: "Filter",
  filters: "Filters",
  forbiddenError: "403 Error",
  generate: "Generate",
  generateNewSecret: "Generate a new secret",
  goBack: "Go back",
  back: "Back",
  https: "https://",
  iban: "IBAN",
  id: "ID",
  inactive: "Inactive",
  incorrect2FASecurityCode: "Incorrect 2FA security code.",
  KEYBOARD_DATE: "dd/MM/yyyy",
  leaveThisPage: "Leave this page",
  leaveWithoutSaving: "Leave without saving",
  list: "List",
  editAddress: "Edit address",
  editDetails: "Edit details",
  paymentConfiguration: "Payment configuration",
  dynamicBeneficiaries: "Dynamic beneficiaries",
  beneficiaries: "Beneficiaries",
  hierarchy: "Hierarchy",
  beneficiaryDetails: "Beneficiary details",
  new: "New",
  Location: "Location",
  Login: "Login",
  mandates: "Mandates",
  manage: "Manage",
  "No results found": "No results found",
  noApplicationFound: "No application found",
  noResponseHasBeenReceived:
    "No response has been received to this test notification.",
  noResults: "No results",
  settlements: "Settlements",
  noResultsFor:
    "There are no results for <strong>{{search}}</strong>, please check the spelling or try different keywords",
  noResultsForSelectedFilters: "There are no results for selected filters",
  moreFiltersText: "+ {{count}} more",
  "Not saved": "Not saved",
  configured: "Configured",
  notConfigured: "Not Configured",
  notFoundError: "404 Error",
  notificationSecret: "Notification secret",
  notificationsQueued: "Notifications queued",
  notificationStatus: "Notification status",
  noSearchResults: "No Search Results",
  Ok: "Ok",
  OK: "OK",
  onboarding: "Onboarding",
  filtersAppliedToThisView: "{{count}} filter applied to this view.",
  filtersAppliedToThisView_plural: "{{count}} filters applied to this view.",
  pageXofY: "Page %currentPage% of %totalPages%",
  Password: "Password",
  paymentAmountMustBeGreaterThan:
    "Payment amount must be greater than {{value}}",
  payments: "Payments",
  payouts: "Payouts",
  pixKey: "PIX Key",
  pleaseEnterAllRequiredFields: "Please, enter all required fields to continue",
  quickFilters: "Quick filters",
  productionMode: "production mode",
  RELATIVE_DATE_TIME: "{{date, RELATIVE_DATE_TIME}}",
  "Remember my email": "Remember my email",
  resend2FA: "Resend 2FA",
  resend2FASuccess: "2FA code has been resent",
  reset: "Reset",
  resetSearch: "Reset Search",
  routingNumber: "Routing number",
  returnToDashboard: "Return to dashboard",
  riskRules: "Risk rules",
  rowsPerPage: "Rows per page",
  sandboxMode: "sandbox mode",
  save: "Save",
  searchCustomers: "Search customers",
  secretHasBeenGenerated: "Secret has been successfully generated!",
  selectAll: "Select all",
  selectCustomer: "Select customer",
  selectFilter: "Select filter",
  selected_plural: "Selected {{count}} options",
  selected: "Selected {{count}} option",
  sendTestNotification: "Send a test notification",
  searchResults: "Search results",
  "Sign out": "Sign out",
  "Sign Up": "Sign Up",
  somethingWentWrong: "Something went wrong.",
  sorrySomethingWentWrong:
    "Sorry, something went wrong. Please try again later.",
  sorryPageNotFound: "Sorry, the page was not found",
  sortCode: "Sort code",
  startSearching: "Start searching",
  stablecoins: "Stablecoins",
  stayOnThisPage: "Stay on this page",
  submitRequest: "Submit request",
  swiftCode: "Swift code (BIC)",
  testNotifications: "Test Notifications",
  testOutcome: "Test outcome",
  theTestNotificationHasFailed:
    "The test notification has failed. Please review the error and try again.",
  thisTimestampInUTC: "This timestamp is in UTC. Your local time would be: ",
  tooManyRequests: "Too many requests. Please, try again later.",
  transactions: "Transactions",
  tryAgain: "Try again",
  tryDifferentKeyword: "Try different keyword",
  typeMinimumCharacters: "Type minimum {{minSearchLength}} characters",
  twoFaCodeHasBeenSentToYourVoltEmail:
    "2FA code has been sent to your Volt e-mail.",
  twoFaSecurityCode: "2FA security code",
  type: "Type",
  today: "Today",
  lastXDays: "Last {{days}} days",
  thisMonth: "This month",
  lastXMonths: "Last {{months}} months",
  typeHere: "Type here...",
  unexpectedError: "Unexpected error",
  updatedBy: "Updated by",
  "User management": "User management",
  Users: "Users",
  useTabAndArrowKeysToNavigate: "Use tab and arrow keys to navigate",
  value: "Value",
  viewError: "View error",
  viewing: "Viewing",
  viewMore: "View more",
  "Volt Merchant": "Volt Merchant",
  webhookUrl: "Webhook URL",
  wallets: "Wallets",
  workflows: "Workflows",
  notificationUrl: "Notification URL",
  urlToReceiveThePayoutInformation: "URL to receive the payout information",
  urlToReceiveTheCreditInformation: "URL to receive the credit information",
  urlToReceiveTheReportInformation: "URL to receive the report information",
  Workflows: "Workflows",
  xYCharactersRemaining_plural: "{{count}}/{{maxNumber}} characters remaining",
  xYCharactersRemaining: "{{count}}/{{maxNumber}} character remaining",
  youDoNotHaveNotifications:
    "You don’t have notifications set up right now, do talk to your system administrator if you think there is an issue or our support team",
  youDoNotHavePermissions: "You don't have permission to access.",
  youDontHavePermissionToPerformThisAction:
    "You don’t have a permission to perform this action.",
  youHaveUnsavedChanges: "You have unsaved changes.",
  yourOneTimePasswordHasExpired:
    "Your one time password has expired. Please resend 2FA.",
  youHaventAppliedTheseFilters: "You haven't applied these filters",
  logout: "Logout",
  generating: "Generating",
  generateReport: "Generate a report",
  reportsCantExceedLastThreeMonths:
    "Reports can’t exceed last 3 months, please refine your filter.",
  reportsHistory: "Reports history",
  reports: "Reports",
  exports: "Exports",
  exportAction: "Export",
  viewExportHistory: "View export history",
  youHaveNoExportHistory: "You have no export history",
  yourExportIsCurrentlyBeingGenerated:
    "Your export is currently being generated and we will let you know when it is available. You can also download it later in the Exports section.",
  listOfExportsIsNotAvailableNow:
    "List of exports is not available now. Please, try again later.",
  generatingWithDots: "Generating...",
  viewReportsHistoryLoading: "Reports history loading...",
  viewReportsHistory: "View reports history",
  youHaveNoReportsHistory: "You have no reports history",
  lastTen: "(last 10)",
  downloadReport: "Download report",
  reportFailedToGenerate: "Report failed to generate",
  reportIsBeingGenerated: "Report is being generated...",
  listOfReportsIsNotAvailableNow:
    "List of reports is not available now. Please, try again later.",
  yourReportIsCurrentlyBeingGenerated:
    "Your report is currently being generated and we will let you know when it is available. You can also download it later in the Reports section.",
  cannotDownloadReportNow:
    "Cannot download report now. Please, try again later",
  search: "Search (3 characters min.)",
  saveChanges: "Save changes",
  youSearchWithoutFiltersAndDateRange:
    "You search without filters and date range",
  youCannotFilterByAmountIfMoreCurrenciesSelected:
    "You cannot filter by amount if more than one currency is selected",
  toGenerateAReportSelectCustomer:
    "To generate a report, please select a customer in the select customer menu in the upper left corner.",
  closeMatch: "Close match",
  fullMatch: "Full match",
  noMatch: "No match",
  payeeVerification: "Payee verification",
  providedName: "Provided name",
  theProvidedNameCloselyMatches:
    "The provided name closely matches the account holder name. Please note that if you authorise this transaction, the funds may be transferred to an account that is not owned by the recipient you indicated.",
  theProvidedNameDoesNotMatch:
    "The provided name does not match the account holder name. Please note that if you authorise this transaction, the funds may be transferred to an account that is not owned by the recipient you indicated.",
  theProvidedNameExactlyMatches:
    "The provided name exactly matches the account holder name.",
  verificationOfPayeeIsInProgress:
    "Verification of Payee is in progress. Please check back in a few moments for the verification results.",
  weWereUnableToObtainTheVerification:
    "We were unable to obtain the Verification of Payee result. The transaction can still be approved at your own risk.",
  searchCountCharactersMin: "Search ({{count}} characters min.)",
} as const;
